import { Data } from '.generated/templates/Feature.Data.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import ImageWrapper from '../ImageWrapper/ImageWrapper';
import { classnames } from 'tailwindcss-classnames';
import { ButtonVariant } from '../Button/WithButton';
import Heading, { propsFromFields } from '../Heading';
import Button from '../Button';
import { useSwiperSlide } from 'swiper/react';
import { onCarouselCtaDataLayerPush, OnLinkDataLayerPushProps } from 'lib/util/gtm-datalayer';
import ImageCaption from '../ImageCaption/ImageCaption';

export type RoundImageCarouselItemProps = Sitecore.Override.ItemEx &
  Data.Carousel.Fields.CarouselItem & {
    index: number;
    carouselName?: string;
  };

const RoundImageCarouselItem = ({
  fields,
  index,
  carouselName,
}: RoundImageCarouselItemProps): React.JSX.Element => {
  const swiperSlide = useSwiperSlide();

  if (!fields) {
    return <></>;
  }

  const headingProps = propsFromFields(fields);

  const contentOpacity = swiperSlide.isActive ? 'opacity-100' : 'opacity-0';
  const cta2TypeField = fields.cta2Type.value?.trim().toLowerCase();
  const cta2Type: ButtonVariant =
    cta2TypeField.length === 0 ? 'primary' : (cta2TypeField as ButtonVariant);

  const handleClickPushGtm = (props: OnLinkDataLayerPushProps) => {
    onCarouselCtaDataLayerPush({
      pushEvent: props,
      index,
      carouselType: 'round image carousel',
      carouselText: carouselName,
    });
  };

  return (
    <div className="round-img-carousel-item">
      <ImageWrapper
        field={fields.image}
        className={classnames('rounded-full', 'transition duration-300 ease-in-out')}
        layout="responsive"
      />
      <div className={classnames(contentOpacity, 'transition duration-300 ease-in-out')}>
        <ImageCaption
          imageCaption={fields.imageCaption}
          classNames={classnames('text-center', 'px-5', 'md:px-0', 'mt-1')}
        />
        <div
          className={classnames(
            'w-[130%]',
            'ml-[-15%]',
            'xl:w-[150%]',
            'xl:ml-[-25%]',
            'md:w-[200%]',
            'md:ml-[-50%]',
            'mx-auto',
            'px-5'
          )}
        >
          <Heading
            {...headingProps}
            headingSize="m"
            headingAlignment="center"
            className={classnames('mt-4')}
            descriptionClassName={classnames('text-base', 'mt-2', 'mb-4')}
          />
          <div className={classnames('cta-container', 'text-center', 'mb-6')}>
            <Button linkField={fields.cta1} onGtmPush={handleClickPushGtm} />
            <Button linkField={fields.cta2} variant={cta2Type} onGtmPush={handleClickPushGtm} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoundImageCarouselItem;
